module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat3@2x-a957d3516e7a8f4550aa5cdb1910176f.jpg";